import { render, staticRenderFns } from "./vocabularyTest.vue?vue&type=template&id=79c80608&scoped=true"
import script from "./vocabularyTest.vue?vue&type=script&lang=js"
export * from "./vocabularyTest.vue?vue&type=script&lang=js"
import style0 from "./vocabularyTest.vue?vue&type=style&index=0&id=79c80608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c80608",
  null
  
)

export default component.exports